import { Track } from '@za/hfe-library-track';
import { XFlowBrowserPlugin } from '@za/hfe-library-track/plugins';
import cookies from './cookie';
import session from './session';
/**
 * 创建并初始化全局追踪实例
 *
 * 该函数创建一个全局的追踪对象，并使用XFlowBrowserPlugin插件进行配置。
 * 创建后立即将追踪器附加到应用程序中。
 *
 * @returns {void}
 */
const initTrack = () => {
  window.__track__ = Track.create({
    plugins: [
      new XFlowBrowserPlugin(
        {
          // extendsInfo: {
          //   // getDynamic为动态扩展字段，如需配置动态扩展字段，需以getDynamic为属性名称，函数体里面放置动态返回的对象
          //   getDynamic() {
          //     return {
          //       ZAHLWYY_channelSource: cookies.get('channelSource') || '',
          //       ZAHLWYY_channelResourceCode: cookies.get('channelResourceCode') || '',
          //       ZAHLWYY_userId: cookies.get('maskusId') || '',
          //       ZAHLWYY_safeUserId: cookies.get('maskusSafeId') || '',
          //       ZAHLWYY_accountId: cookies.get('maskActId') || '',
          //       ZAHLWYY_channelOrigin: session.getSessionStorage('channelOrigin') || '',
          //       ZAHLWYY_channelCode: session.getSessionStorage('channelCode') || '',
          //       ZAHLWYY_hyChannelCode: session.getSessionStorage('hyChannelCode') || '',
          //     };
          //   },
          // },
        }
      ),
    ],
  });

  window.__track__?.setXFlowOptions({
    openXcxJsBridge: true,
    extendsInfo: {
      // getDynamic为动态扩展字段，如需配置动态扩展字段，需以getDynamic为属性名称，函数体里面放置动态返回的对象
      getDynamic() {
        return {
          ZAHLWYY_channelSource: cookies.get('channelSource') || '',
          ZAHLWYY_channelResourceCode: cookies.get('channelResourceCode') || '',
          ZAHLWYY_userId: cookies.get('maskusId') || '',
          ZAHLWYY_safeUserId: cookies.get('maskusSafeId') || '',
          ZAHLWYY_accountId: cookies.get('maskActId') || '',
          ZAHLWYY_channelOrigin: session.getSessionStorage('channelOrigin') || '',
          ZAHLWYY_channelCode: session.getSessionStorage('channelCode') || '',
          ZAHLWYY_hyChannelCode: session.getSessionStorage('hyChannelCode') || '',
        };
      },
    },
  });

  window.__track__?.attach?.();
};

export default initTrack;
